import '@/app/app.css';
import './delivery.css';

import '@/app/app';
import '@/layouts/main/main';

window.addEventListener('DOMContentLoaded', () => {});
